import React from 'react'
import { inject, observer } from 'mobx-react'
import { LinkVerificationResult, RegistrationStore } from '../../stores/registration-store'
import Button from '@material-ui/core/Button'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import CircularProgress from '@material-ui/core/CircularProgress'

const SuccessMark = require('../../assets/success-mark.svg')
const FailureMark = require('../../assets/failure-mark.svg')
const styles = require('./link-verification.module.scss')

interface LinkVerificationProps extends RouteComponentProps<{ linkId: string }> {
    registrationStore?: RegistrationStore
}

const LinkVerificationInner: React.FC<LinkVerificationProps> = inject(
    RegistrationStore.storeName,
)(observer(
    props => {
        const { linkVerificationResult, checkVerificationLink } = props.registrationStore
        const { linkId } = props.match.params

        React.useEffect(() => {
            checkVerificationLink(linkId)
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [])

        if (linkVerificationResult === null) {
            return (
                <div className={styles.background} style={{ justifyContent: 'center' }}><CircularProgress/></div>
            )
        }

        let verified = linkVerificationResult === LinkVerificationResult.VERIFIED
        let success = linkVerificationResult === LinkVerificationResult.SUCCESS || verified

        // Отключено пока нет бэка
        let companyName = ''
        let messageText = verified ? 'Подтверждение уже выполнено' : 'Подтверждение прошло успешно!'
        let buttonText = 'ПЕРЕЙТИ НА САЙТ'
        let buttonLink = ''

        let errorText = 'Ошибка подтверждения'

        let buttonURL = buttonLink
        if (buttonURL.search('http') !== 0) {
            buttonURL = `https://${buttonURL}`
        }

        const button = buttonLink ? (
            <Button
                color="primary"
                variant="contained"
                href={buttonURL}
            >
                {buttonText}
            </Button>
        ) : null

        return (
            <div className={styles.background}>
                <div className={styles.content}>
                    <div className={styles.text}>{companyName}</div>

                    {success ? (
                        <>
                            <img id="successIcon" src={SuccessMark} className={styles.icon} alt="Success" />
                            <div id="successText" className={styles.text}>{messageText}</div>
                        </>
                    ) : (
                        <>
                            <img id="errorIcon" src={FailureMark} className={styles.icon} alt="Error" />
                            <div id="errorText" className={styles.text}>{errorText}</div>
                        </>
                    )}
                </div>

                {success && (button)}
            </div>
        )
    }
))

export const LinkVerification = withRouter(LinkVerificationInner)
